import { ForestOwnerAssociation } from '@features/ForestOwner/EditShareOwnership/ForestOwnerAssociation/ForestOwnerAssociation'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/forestOwnerAssociation/',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-forestownerassociation.description'),
  },
})

function RouteComponent() {
  return <ForestOwnerAssociation />
}
